<div id="os-login" style="font-family: 'Work Sans';">
    <div class="bg-login">
        <!--img src="assets/images/bg-login-02.jpg"-->
        <mdb-carousel [attr.id]="'loginCarousel'" [controls]="false" [indicators]="false" [animation]="'fade'" [pause]="false" [keyboard]="false" [interval]="4000">
          <mdb-carousel-item></mdb-carousel-item>
          <mdb-carousel-item></mdb-carousel-item>
          <mdb-carousel-item></mdb-carousel-item>
          <mdb-carousel-item></mdb-carousel-item>
        </mdb-carousel>
    </div>
  <div class="form-login container h-100 m-0" [ngStyle]="{'opacity': isLoading ? '0.5' : '1'}">
      <div class="h-100 w-100 d-flex flex-column justify-content-center align-items-center">
        <div class="login-box">
            <p class="text-center mb-4">
                <img src="assets/images/intro.png" alt="Garibaldi" class="logo">
            </p>
            <form [formGroup]="form" >
                <div class="row">
                    <div class="col-md-12 mb-3 text-center mb-4 text-uppercase">
                        <h2 class="title"  >Bienvenido</h2>
                    </div>
                    <!-- mdb-select -->
                    <!--<div class="col-md-12 mb-3">
                        <mdb-form-control>
                            <mdb-select formControlName="dc" (valueChange)="onCompanySelected($event)">
                            <mdb-option *ngFor="let option of domain" [value]="option.dc">{{ option.label }}</mdb-option>
                            </mdb-select>
                            <label mdbLabel class="form-label">Seleccione Empresa</label>
                        </mdb-form-control>
                    </div> -->
                    <!-- samAccountName input -->
                    <div class="col-md-12 mb-3">
                        <mdb-form-control>
                            <input mdbInput type="samAccountName" class="form-control" formControlName="samAccountName" />
                            <label mdbLabel class="form-label">Usuario</label>
                        </mdb-form-control>
                    </div>
                    <!-- Password input -->
                    <div class="col-md-12 mb-4">
                        <mdb-form-control>
                            <input mdbInput type="{{ showPassword ? 'text' : 'password' }}" id="form2Example2" class="form-control" formControlName="password" (keypress)="onEnter($event)"/>
                            <label mdbLabel class="form-label" for="form2Example2">Clave</label>
                            <div class="input-group-append">
                            <span class="input-group-text btn-toggle-password" (click)="togglePasswordVisibility()">
                                <i [ngClass]="showPassword ? 'fa fa-eye' : 'fa fa-eye-slash'"></i>
                            </span>
                            </div>
                        </mdb-form-control> 
                    </div>
                    <!-- Submit button -->
                    <div class="col-md-12 mb-3 text-center">
                        <button (click)="login()" mdbRipple type="button" class="btn btn-primary mb-4" [disabled]="form.invalid  || loading">
                            <span *ngIf="loading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span> 
                        Acceder</button>
                    </div>
                </div>    
            </form>
        </div>
        <div class="logo-box text-center px-5">
          <img src="assets/images/logos-login.svg" alt="Logos Garibaldi Group" class="logos-garibaldi w-100">
        </div>
      </div>
    </div>
</div>




<style>
 /*  .login-form {
  max-width: 500px;
  margin: 0 auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  background-color: #f5f5f5;
}

.login-form__title {
  font-size: 24px;
  text-align: center;
  margin-bottom: 20px;
}

.login-form__input {
  width: 100%;
  margin-bottom: 15px;
}

.login-form__button {
  width: 100%;
}

@media (max-width: 768px) {
  .login-form {
    max-width: 100%;
  }
}

*/

</style>  